<div class="container" >
    <!--img class="ecoLogo" src="assets/images/picto03_ecolo.svg" alt="logo Eco Responsable"-->
    <div class="labelEco" *ngIf="isMobile">{{"bloc-eco.responsible_delivery_mobile" | translate}}
    </div>
    <div class="labelEco" *ngIf="!isMobile">{{"bloc-eco.responsible_delivery" | translate}}
    </div>
</div>